/* 
  Deprecated, use common/Select instead.
*/

import React , { useState, useEffect, useRef } from 'react';

const DataSelection = ({fields, selected, onSelect, onRemoveSelect, name, searchable = false}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [selectIndex, setSelectIndex] = useState(null);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);


  const filteredFields = (searchable && search.length > 1 ? fields.filter(f => f.label.toLowerCase().includes(search.toLowerCase())) : fields).filter(f => !selected.find(s => s.value == f.value));

  const toggleOpen = () => { 
    if (searchable) {
      if (open){
        inputRef.current.blur();
        setSearch('');
      } else {
        inputRef.current.focus();
      }
    }
    setOpen(!open);
  };


  const onOutsideClick = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)){
      setOpen(false);
    }
  }

  const handleSelect = (item) => {
    setSearch("");
    onSelect(item);
  }

  const handleHighlight = (e) => {
    if (open) { 
      switch (e.key) {
        case 'ArrowDown':
          setSelectIndex(selectIndex == null ? 0 : Math.min(selectIndex + 1, filteredFields.length - 1));
          break;
        case 'ArrowUp':
          setSelectIndex(Math.max(0, selectIndex - 1))
          break;
        case 'Enter':
          if (selectIndex != null){
            handleSelect(filteredFields[selectIndex]);
            setSelectIndex(null);
          }
          break;
        case 'Escape': 
          setOpen(false);
          inputRef.current.blur();
      }
    }
  }
  
  useEffect(() => {
    window.addEventListener('click', onOutsideClick)
    return () => {window.removeEventListener('click', onOutsideClick)}
  }, [])



  return <div className={`data-select-wrapper ${open && 'open'}`} ref={wrapperRef}  onKeyDown={handleHighlight}>
    <div className={`data-select`} onClick={toggleOpen}>
      {selected.map(s => <SelectedItem key={s.value} item={s} onRemoveSelect={onRemoveSelect}/>)}
      <input 
        type="text" 
        value={search} 
        onChange={(e) => {setSearch(e.target.value); setSelectIndex(null)}}
        ref={inputRef}
        className='no-border'
      />
      <i className="fa fa-caret-down"/>
    </div>
    {open && 
      <div className="dropdown">
          { filteredFields.map((f,idx) => <SelectItem key={f.value} item={f} onSelect={handleSelect} highlight={selectIndex == idx} />) }
          {searchable && filteredFields.length == 0 ? <div style={{padding: '0.5rem 1.5rem', opacity: 0.75}}>{I18n.t('no_matching_fields_found')}</div> : ''}
      </div>
    }
    {name ?
      selected.length > 0 ?
        selected.map(s => <input key={name + s.value} type="hidden" name={name} defaultValue={s.value}/>)
        : <input type="hidden" name={name} />
      : null
    }

  </div>
}

const SelectItem = ({item, onSelect, highlight}) => {
  return <div className={"dropdown-item " + (highlight ? 'highlight' : '') } onClick={() => { onSelect(item) }}>{item.label ? item.label : I18n.t(item.label_key)}</div>
}

const SelectedItem = ({item, onRemoveSelect}) => {
  return <div className="selected-item">
    <div className="pull-left">{item.label ? item.label : I18n.t(item.label_key)}</div>
    <div className="close" onClick={(e) => { e.stopPropagation(); onRemoveSelect(item) }}>x</div>
  </div>
}

export default DataSelection;